import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["menu", "backdrop"];

  connect() {
    // Close when pressing escape
    document.addEventListener("keydown", this.handleKeydown.bind(this));
    // Close mobile menu on Turbo navigation
    document.addEventListener("turbo:before-visit", this.close.bind(this));
    document.addEventListener("turbo:before-cache", this.close.bind(this));
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleKeydown.bind(this));
    document.removeEventListener("turbo:before-visit", this.close.bind(this));
    document.removeEventListener("turbo:before-cache", this.close.bind(this));
  }

  handleKeydown(event) {
    if (
      event.key === "Escape" &&
      !this.menuTarget.classList.contains("pointer-events-none")
    ) {
      this.close();
    }
  }

  toggle() {
    if (this.menuTarget.classList.contains("pointer-events-none")) {
      this.open();
    } else {
      this.close();
    }
  }

  open() {
    // Remove pointer-events-none and start animation
    this.menuTarget.classList.remove("pointer-events-none");
    this.backdropTarget.classList.remove("pointer-events-none");

    // Force a reflow to ensure the transition works
    this.menuTarget.offsetHeight;

    // Add visible state classes
    this.menuTarget.classList.remove("opacity-0", "scale-95");
    this.menuTarget.classList.add("opacity-100", "scale-100");
    this.backdropTarget.classList.remove("opacity-0");
    this.backdropTarget.classList.add("opacity-100");
  }

  close() {
    // Start close animation
    this.menuTarget.classList.remove("opacity-100", "scale-100");
    this.menuTarget.classList.add("opacity-0", "scale-95");
    this.backdropTarget.classList.remove("opacity-100");
    this.backdropTarget.classList.add("opacity-0");

    // Add pointer-events-none after animation completes
    setTimeout(() => {
      this.menuTarget.classList.add("pointer-events-none");
      this.backdropTarget.classList.add("pointer-events-none");
    }, 200);
  }
}
